import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Sobre from "@/pages/Sobre";
import Solucoes from "@/pages/Solucoes";
import Setores from "@/pages/Setores";
import Projetos from "@/pages/Projetos";
import Insights from "@/pages/Insights";
import Contato from "@/pages/Contato";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/sobre" element={<Sobre />} />
              <Route path="/solucoes" element={<Solucoes />} />
              <Route path="/setores" element={<Setores />} />
              <Route path="/projetos" element={<Projetos />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/contato" element={<Contato />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
